import { createAction } from 'redux-actions-helpers';

export const add = createAction('@@tasks/ADD', (task) => task);

export const edit = createAction('@@tasks/EDIT', (task) => task);

export const del = createAction('@@tasks/DEL', (index) => ({
    index
}));



// WEBPACK FOOTER //
// ./src/blocks/tasks/actions.js